import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceGroupEditItemValidityDialogStore } from './service-group-edit-item-validity-dialog.store';
import { ReactiveFormsModule } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { fb } from '../../../../../shared/shared.global-service';
import { AppFormGroup } from '../../../../../../utils/form.utils';
import { contentGlobalSuccess } from '../../../../content.error';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { dateify } from '@libs/types/src/common/utils/date.utils';

@Component({
    selector: 'app-service-group-edit-item-validity-dialog',
    templateUrl: 'service-group-edit-item-validity-dialog.component.html',
    styleUrl: 'service-group-edit-item-validity-dialog.component.scss',
    providers: [ServiceGroupEditItemValidityDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        DateInputComponent,
    ],
})
export class ServiceGroupEditItemValidityDialogComponent extends BaseDialogComponent {
    public readonly store = inject(ServiceGroupEditItemValidityDialogStore);

    protected item!: any;
    private promise!: (data: any) => Promise<any>;

    protected form = new AppFormGroup({
        validFrom: fb.control<Date>(new Date()),
        validTo: fb.control<Date | null>(null),
    });

    constructor() {
        super();
        this.item = this.dialogConfig.data.item;
        this.promise = this.dialogConfig.data.promise;

        this.form.patchValue({
            validFrom: dateify(this.item.validFrom),
            validTo: dateify(this.item.validTo),
        });
    }

    override save(_event: Event): void | Promise<void> {
        if (isInvalid(this.form) || !this.item.id) return;

        const data = {
            id: this.item.id,
            validFrom: this.form.value.validFrom?.toISOString(),
            validTo: this.form.value.validTo?.toISOString(),
        };

        this.promise(data)
            .then(() => {
                contentGlobalSuccess.next('common.updated');
                this.dialogRef.close({ refresh: true });
            });
    }
}
